export const handleChangeDataBottomSheetProducts = (name, value) => ({
    type: 'CHANGE_DATA_BOTTOM_SHEET_PRODUCTS', name, value
});